const apiEnv: string =
	process.env.REACT_APP_API_ENV !== undefined
		? process.env.REACT_APP_API_ENV.toString()
		: 'DEV'
const apiPort: string =
	process.env.REACT_APP_API_PORT !== undefined ? process.env.REACT_APP_API_PORT : '80'
const apiVersion: string = process.env[`REACT_APP_API_${apiEnv}_VERSION`] || 'latest'
const apiHost: string = process.env[`REACT_APP_API_${apiEnv}_URL`] || 'http://localhost'
const apiBaseUrl = `${apiHost}:${apiPort}/${apiVersion}`

const config = {
	api: {
		env: apiEnv,
		port: apiPort,
		version: apiVersion,
		url: apiBaseUrl,
	},
}
export default config
